var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from 'lodash';
import moment from "moment";
import { Messages } from 'primereact/messages';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { createVolumePromotion } from "../../classes/definitions/volumePromotion/volumePromotion";
import ApiRequests from "../../classes/http/ApiRequests";
import HttpRequests from "../../classes/http/HttpRequests";
import NotosService from "../../classes/notos.service";
import AppRoutes from "../../config/appRoutes";
import volumePromotionSchema from "../../schemas/volumePromotionSchema";
import Input from "../UI/Input/Input";
var VolumePromotionForm = /** @class */ (function (_super) {
    __extends(VolumePromotionForm, _super);
    function VolumePromotionForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.editId = '';
        _this.messages = null;
        _this.state = {
            formConfig: _.cloneDeep(volumePromotionSchema),
            formIsValid: false,
            discardPopupVisble: false,
        };
        _this.getVolumePromotion = function () {
            _this.api.getVolumePromotion(_this.editId)
                .then(function (response) {
                _this.setDataToForm(_.get(response, 'data.data', {}));
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при зареждане на количествена промоция';
                _this.http.handleError(error, _this.messages, defaultMessage, _this.props.history);
            });
        };
        _this.setDataToForm = function (data) {
            var volumePromotion = createVolumePromotion(_.get(data, 'attributes', {}));
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            _.set(updatedFormConfig, 'name.value', volumePromotion.Name);
            _.set(updatedFormConfig, 'name.touched', true);
            _.set(updatedFormConfig, 'name.valid', true);
            _.set(updatedFormConfig, 'begin_date.value', new Date(volumePromotion.BeginDate));
            _.set(updatedFormConfig, 'begin_date.touched', true);
            _.set(updatedFormConfig, 'begin_date.valid', true);
            _.set(updatedFormConfig, 'end_date.value', new Date(volumePromotion.EndDate));
            _.set(updatedFormConfig, 'end_date.touched', true);
            _.set(updatedFormConfig, 'end_date.valid', true);
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        // handles input and blur events
        _this.eventHandlers = function (event, id, eventType) {
            var updatedFormConfig = __assign({}, _this.state.formConfig);
            var updatedFormElement = __assign({}, updatedFormConfig[id]);
            updatedFormElement.value = event.target.value;
            updatedFormElement.valid = NotosService.checkFieldValidity(updatedFormElement.value, updatedFormElement.validation, eventType);
            updatedFormElement.touched = true;
            updatedFormConfig[id] = updatedFormElement;
            _this.setState({
                formConfig: updatedFormConfig,
                formIsValid: NotosService.checkFormValidity(updatedFormConfig),
            });
        };
        _this.submitForm = function (event) {
            event.preventDefault();
            var formData = _this.state.formConfig;
            var beginDate = moment(_.get(formData, 'begin_date.value', ''));
            var endDate = moment(_.get(formData, 'end_date.value', ''));
            var isEdit = _this.editId !== "-1";
            var submitForm = new FormData();
            submitForm.append("volume_promotion[name]", _.get(formData, 'name.value', ''));
            submitForm.append("volume_promotion[begin_date]", beginDate.format("YYYY-MM-DD"));
            submitForm.append("volume_promotion[end_date]", endDate.format("YYYY-MM-DD"));
            var actionMethod = isEdit ? _this.api.updateVolumePromotion(submitForm, _this.editId) : _this.api.createVolumePromotion(submitForm);
            actionMethod
                .then(function (response) {
                _this.toListPage();
            })
                .catch(function (error) {
                var defaultMessage = 'Грешка при създаване на количествена промоция';
                var editMessage = "Грешка при ъпдейт на количествена промоция";
                _this.http.handleError(error, _this.messages, isEdit ? editMessage : defaultMessage, _this.props.history);
            });
        };
        _this.toListPage = function () {
            _this.props.history.push(AppRoutes.volumePromotions.path);
        };
        return _this;
    }
    VolumePromotionForm.prototype.componentDidMount = function () {
        this.editId = _.get(this.props, 'match.params.id', '-1');
        if (this.editId !== '-1') {
            this.getVolumePromotion();
            this.props.setEdit(true);
        }
    };
    VolumePromotionForm.prototype.render = function () {
        var _this = this;
        var _a = this.state, formConfig = _a.formConfig, formIsValid = _a.formIsValid;
        var formElementsArray = [];
        // turning the formConfig from an object to an array
        for (var key in formConfig) {
            if (formConfig.hasOwnProperty(key)) {
                formElementsArray.push({
                    config: formConfig[key],
                    id: key,
                });
            }
        }
        // Building form inputs
        var form = formElementsArray.map(function (formElement) {
            return (React.createElement(Input, { key: formElement.id, id: formElement.id, elementType: formElement.config.elementType, elementConfig: formElement.config.elementConfig, label: formElement.config.label, className: formElement.config.className, value: formElement.config.value, invalid: !formElement.config.valid, shouldValidate: formElement.config.validation, touched: formElement.config.touched, errorMsg: formElement.config.errorMsg, maxLength: formElement.config.maxLength, changed: function (event) { return _this.eventHandlers(event, formElement.id, 'onChange'); }, blur: function (event) { return _this.eventHandlers(event, formElement.id, 'onBlur'); } }));
        });
        var actionBtns = (React.createElement("div", { className: "modal-footer" },
            React.createElement("button", { className: "btn btn-sm btn-outline-primary", onClick: this.toListPage, type: "button" },
                React.createElement("i", { className: "fa fa-ban" }),
                " \u041E\u0442\u043A\u0430\u0437"),
            React.createElement("button", { className: "btn btn-sm btn-primary", onClick: this.submitForm, disabled: !formIsValid, type: "button" },
                React.createElement("i", { className: "fa fa-dot-circle-o" }),
                " OK")));
        return (React.createElement(React.Fragment, null,
            React.createElement(Messages, { ref: function (el) {
                    _this.messages = el;
                } }),
            form,
            actionBtns));
    };
    return VolumePromotionForm;
}(React.Component));
// @ts-ignore
export default withRouter(VolumePromotionForm);



//////////////////
// WEBPACK FOOTER
// ./src/components/VolumePromotions/VolumePromotionForm.tsx
// module id = 511
// module chunks = 0